/**
 * "Can this client hold a consent preference?", for loading the CMP. Never an error-reporting gate: TEC-3747
 * looked like crawler noise and was our bug. Independent of `html-limited-bots.ts`, which decides what is SERVED.
 */

/**
 * Substrings, because Meta's token hides inside `(compatible; ...)`. Not `whatsapp`, `instagram`, `fbav` or
 * `line`: those are also in-app browsers, whose donors are owed a consent banner.
 */
const DECLARED_CRAWLERS = [
	// `meta-externalagent` is TEC-3747's; the other two are Meta's older link scrapers.
	'meta-externalagent',
	'facebookexternalhit',
	'facebookcatalog',
	// Search engines.
	'googlebot',
	'google-inspectiontool',
	'storebot-google',
	'chrome-lighthouse',
	'bingbot',
	'bingpreview',
	'applebot',
	'duckduckbot',
	'yandexbot',
	'baiduspider',
	'seznambot',
	'petalbot',
	'slurp',
	'sogou',
	// AI and dataset crawlers.
	'gptbot',
	'oai-searchbot',
	'chatgpt-user',
	'claudebot',
	'claude-web',
	'anthropic-ai',
	'perplexitybot',
	'amazonbot',
	'bytespider',
	'ccbot',
	// SEO and archival.
	'ahrefsbot',
	'semrushbot',
	'mj12bot',
	'dotbot',
	'ia_archiver',
	// Link unfurlers.
	'twitterbot',
	'linkedinbot',
	'slackbot',
	'discordbot',
	'telegrambot',
	'redditbot',
	'pinterestbot',
	'embedly',
	'quora link preview',
	'vkshare',
	'tumblr',
	'bitlybot',
];

/** The slash in `bot/` is load-bearing: a bare `bot` matches phones such as `CUBOT NOTE 20`. */
const CONVENTIONAL_CRAWLER = /[a-z0-9._-]bot\/|crawler|spider|\+http/;

/** A missing user agent is a person: withholding the banner from one is a consent defect, the reverse costs bandwidth. */
export function isCrawlerUserAgent(userAgent: string | undefined): boolean {
	if (!userAgent) return false;
	const ua = userAgent.toLowerCase();
	return DECLARED_CRAWLERS.some((crawler) => ua.includes(crawler)) || CONVENTIONAL_CRAWLER.test(ua);
}
